module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/badges/now-with-ai-badge-advanced.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/badges/now-with-ai-badge-advanced.png
// module id = ZQh9
// module chunks = 0